"use strict";

import { auth, keyGeneration } from "./auth.reducer";

import {
  successMessageReducer,
  errorMessageReducer,
  frontEndMessageReducer,
} from "./message.reducer";
import { loadingSpinnerReducer } from "./loading.spinner.reducer";

import {
  bankListReducer,
  commonDataReducer,
  firstTimeLoginReducer,
  hasChangedFormReducer,
  receiptDownloadReducer,
} from "./common.reducer";

import { notification } from "./notification.reducer";

import {
  setting,
  settingAccountPreferences,
  settingCreditCardPreferences,
  settingCustomerProfile,
  settingTransferLimits,
} from "./setting.reducer";

import { dashboard } from "./dashboard.reducer";
import { account } from "./account.reducer";
import { profile } from "./profile.reducer";
import { lang } from "./lang.reducer";
import { fixedDeposits } from "./fixedDeposits.reducer";
import { creditCardReducer } from "./creditCard.reducer";
import { creditCardPaymentsReducer } from "./creditCardPayments.reducer";
import { loans } from "./loans.reducer";
import { generalBillPayements } from "./generalBillPayments.reducer";
import { favourites } from "./favourites.reducer";
import { fundTransferReducer } from "./fundTransfer.reducer";
import { trafficFineReducer } from "./trafficFine.reducer";
import { history } from "./history.reducer";
import { onboarding } from "./onboarding.reducer";
import { myPortfolio } from "./portfolio.reducer";
import { serviceRequest } from "./serviceRequest.reducer";
import {
  secureEmailReducer,
  secureMailDraftReducer,
  secureMailListReducer,
  secureMailMessageListReducer,
} from "./secureEmail.reducer";
import { schedulePaymentsReducer } from "./schedulePayments.reducer";

export default {
  auth,
  lang,
  loading: loadingSpinnerReducer,
  successMessage: successMessageReducer,
  errorMessage: errorMessageReducer,
  frontEndMessage: frontEndMessageReducer,
  bankList: bankListReducer,
  notification: notification,
  receiptDownload: receiptDownloadReducer,
  firstTimeLogin: firstTimeLoginReducer,
  checkForm: hasChangedFormReducer,
  settingAccountPreferences,
  setting,
  settingCreditCardPreferences,
  settingCustomerProfile,
  settingTransferLimits,
  keyGeneration,

  // dfcc
  fixedDeposits,
  loans,
  fixedDeposits,
  generalBillPayements,
  favourites,
  dashboard,
  profile,
  account,
  commonData: commonDataReducer,

  //Credit Card
  creditCardReducer,
  creditCardPayments: creditCardPaymentsReducer,

  //fundTransfer
  fundTransfers: fundTransferReducer,

  history,

  // onboarding

  onboarding,

  //myPortfolio
  myPortfolio,

  //serviceRequest
  serviceRequest,

  //secureEmail
  secureEmail: secureEmailReducer,
  secureEmailDraft: secureMailDraftReducer,
  secureMailLists: secureMailListReducer,
  secureMailMessageList: secureMailMessageListReducer,

  trafficFines: trafficFineReducer,

  //schedulePayments
  schedulePayments: schedulePaymentsReducer,
};
